<div class="new_assets_hover"  (mouseenter)="onMouseEnter(item)"  (mouseleave)="item_hover_leave(item)" (click)="handleClick(item, $event)" [id]="'hover_video_value'+item.code+item.category_slug" [ngClass]="{'hover_video_value': (item.code == checkPrview)}">
    <div class="hover_video" >
       <a class="hover-click">
        <image-manipulation class="asset_hover_img"
           
            [img]="item.image_landscape || item.image" [params]="{'width':448,'height':252}"
            [notFound]="'landscape'" [id]="'asset_hover_img'+item.code+item.category_slug"></image-manipulation>
        <!-- <image-manipulation class="asset_hover_img"
            [img]="item.image_landscape || item.image" [params]="{'width':1280,'height':720}"
            [notFound]="'landscape'" [id]="'asset_hover_img'+item.code+item.category_slug"></image-manipulation>
         -->
        <div [hidden]="true" #hoverContainer class="hover_video_play" [id]="'hover_video_play'+item.code+item.category_slug" *ngIf="item.code == checkPrview">
            <div class="video_img_icon">
                
                <div class="video_mute_icon" [id]="'video_mute_icon'+item.code+item.category_slug" (click)="togglePreviewVideoMute(item, $event)" >
                    <img *ngIf="!isPreviewVideoMuted" src="../../../assets/img/Icon/unmute.svg" />
                    <img *ngIf="isPreviewVideoMuted" src="../../../assets/img/Icon/mute.svg" />
                </div>
                
            </div>
           

            <video  #sharedHoverVideo style="z-index: -9;" [id]="'hoverPreviewVideo'+item.code+item.category_slug"
                class="video-js vjs-fluid  vjs-16-9" controls autoplay
                preload="auto" playsinline>
                <p class="vjs-no-js">
                   {{'toViewThisVideoPleaseEnableJavaScript' | translate}}
                    <a href="https://videojs.com/html5-video-support/"
                        target="_blank">{{'supportsHtml5Video' | translate}}</a>
                </p>
            </video>
        </div>
    </a>

            <a class="_premium"
                *ngIf="strToLower(item.content_availability) == 'paid' && item.hide_tag == '0' ">
                <img class="crown" [src]="paidIcon">
            </a>

            <a class="_free_tag"
                *ngIf="strToLower(item.content_availability) == 'free' && item.hide_tag == '0' ">
                <img class="crown" [src]="freeIcon">
            </a>

            <a class="_free_tag"
                *ngIf="strToLower(item.content_availability) == 'no tag' && item.hide_tag == '0' ">
            </a>

            <a class="_cross_icon"
                *ngIf="strToLower(item?.category_type) == 'continue-watching' || isContinueWatching">
                <img class="crown" (click)="deleteFromContinueWatching($event, item)"
                    src="assets/img/Icon/close.svg">
            </a>
        <div class="transparent_img_text">
            <!-- <div *ngIf="item.image_transparent" class="video_transpreant_img">
                <img [src]="item.image_transparent" />
            </div> -->
            <div *ngIf="item.image_transparent" class="video_transpreant_img">
                <!-- <img src="../../../assets/img/nexgtv.png" /> -->
                <!-- <img [src]="item.image_transparent" /> -->
                <image-manipulation
                    [img]="item?.image_transparent" params="{width:auto, height:auto}">
                </image-manipulation>
            </div>
            <span *ngIf="!item.image_transparent && (item.type == 'episode' || item.type == 'tvshow') && (strToLower(item?.category_type) == 'continue-watching' || isContinueWatching)" >
                {{commonService.slugToTitle((strToLower(item?.category_type) == 'continue-watching' || isContinueWatching) ? item.series_name : item.name)}}
                
                <small class="continue_series"> {{'s' | translate}}{{item.season_number}}  {{'e' | translate}}{{item.episode_number}}: {{item.name}}</small>
            
            </span>
            <span *ngIf="!item.image_transparent &&  item.type != 'episode' && item.type != 'tvshow' && isContinueWatching" >{{item.name}}
            </span>
            <span *ngIf="!item.image_transparent && !isContinueWatching" >{{item.name}}
            </span>


           
        </div>
        
    </div>
    <div class="new_assets_hover_info">
        <div class="assets_button">
            <button style="overflow: hidden;" type="button" class="play_btn btn_hover blur-btn" (click)="redirectUrl(item, $event,true);$event.stopPropagation()">
                <img src="../../../assets/img/Icon/play.svg" /> 
            
                 {{(item.type === 'livetv' ? 'watchLive' : item?.playing_duration && item.playing_duration > 0  ? 'resumeNow' : 'watchNow') | translate}}

                <div class="new_asset_seekbar_info" style="position: absolute; bottom: 0;"
                    *ngIf="item.type!== 'livetv' && item?.playing_duration && item.playing_duration > 0">
                    <span [ngStyle]="{'width': item.playing_duration*100/item.duration+'%', 'min-width': '12px'}"></span>
                </div>
            </button> <!--  *ngIf="strToLower(item.content_availability) == 'free'" -->

            <!-- <button *ngIf="strToLower(item.content_availability) == 'paid'" type="button" class="play_btn btn_hover subscribe-animation blur-btn"
                (click)="redirectUrl(item, $event, true)">
                <span class="top-star" [ngClass]="{'star-animation': isStarAnimation}"><img src="../../../assets/img/Icon/star.svg" /></span>
                <div class="subscribe-animation-line" [ngClass]="{'fade-line-animation': isStarAnimation}">
                    <img src="../../../assets/img/Icon/subscribe.svg" />
                    Subscribe to Watch
                </div>
                <span class="bottom-star" [ngClass]="{'star-animation': isStarAnimation}"><img src="../../../assets/img/Icon/star.svg" /></span>
            </button> -->

            <button #watchlistButton (click)="addRemoveFromWatchlist(item, watchlistButton, $event)" class="add_watch_btn add_watch_list_btn btn_hover blur-btn">
                <img *ngIf="item?.is_watchlist_added == undefined || item?.is_watchlist_added == 0"
                src="../../../assets/img/Icon/plush.svg" />
                <img *ngIf="item?.is_watchlist_added == 1" src="../../../assets/img/Icon/check.svg" />
            </button>
             <span *ngIf="item?.is_watchlist_added == 0" class="tooltip_hover home_tooltip">{{'watchlist.title' | translate}}</span>
            <span *ngIf="item?.is_watchlist_added == 1" class="tooltip_hover home_tooltip">{{'addedToWatchlist' | translate}}</span>
        </div>
        <div class="assets_info_label">
            <ul>
                <!-- Corrected the conditions and terminology for genres and languages -->
                <li *ngIf="item.languages?.length > 1">
                    {{item.languages.length}} {{'languages' | translate}}
                    <!-- <span class="tooltip_hover">
                        <p *ngFor="let language of item.languages">{{language}}</p>
                    </span> -->
                </li>
                <li *ngIf="item.languages?.length === 1">
                    {{item.languages[0]}}
                </li>
                <li *ngIf="item.type !== 'livetv' && item.type !== 'event' && item.duration && item.duration != '0'">{{commonService.convertSecondsToTime(item.duration)}}</li>
                <li *ngIf="item.genre?.length > 1">
                   {{item.genre.length}} {{'genres' | translate}}
                    <!-- <span class="tooltip_hover">
                        <p *ngFor="let genre of item.genre">{{genre}}</p>
                    </span> -->
                </li>
                <li *ngIf="item.genre?.length === 1">
                    {{item.genre[0]}}
                </li>
                <li *ngIf="item.genre_text?.length > 1">
                    {{item.genre_text.length}} {{'genres' | translate}}
                    <!-- <span class="tooltip_hover">
                        <p *ngFor="let genre_text of item.genre_text">{{genre_text}}</p>
                    </span> -->
                </li>
                <li *ngIf="item.genre_text?.length === 1">
                    {{item.genre_text[0]}}
                </li>
            </ul>
            
            <span *ngIf="item.type !== 'livetv' && item.type !== 'event'"  class="slider_rating">{{item.viewer_rating?.rating_name}}</span>
            <span *ngIf="item.type === 'livetv'" class="asset_live_tag">{{'live' | translate}}</span>
            <span *ngIf="item.type === 'event'" class="asset_live_tag">{{'liveEvent' | translate}}</span>
        </div>
        <div class="assets_info_des">
            <span class="synopsis_text" *ngIf="item.synopsis?.length <= 200">{{item.synopsis}}</span>
            <span class="synopsis_text" *ngIf="item.synopsis?.length > 200">{{item.synopsis | slice:0:200}}...</span>
        </div>
    </div>
</div>

<ng-template #loginModal let-modal>
    <app-login-register (onModalClose)="closeLoginModal($event)"></app-login-register>
</ng-template>